import type { UseMutationOptions } from '@tanstack/react-query';
import type { EmptyObject } from 'type-fest';

import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

import { getUserMasqueradeQueryKey } from './useGetUserMasquerade';

async function unmask() {
  return post<EmptyObject, void>('/api/users/masquerade/unmask', {});
}

type UnmaskResponse = Awaited<ReturnType<typeof unmask>>;

type UnmaskOptions = Omit<UseMutationOptions<UnmaskResponse, Error, void>, 'mutationFn'>;

/**
 * Unmask the super admin.
 */
export default function useUnmask(options?: UnmaskOptions) {
  return useToastedMutation({
    mutationFn: () => unmask(),
    onSuccess: () => {
      // Invalidate the masquerade status query to clear the masked user
      queryClient.invalidateQueries({ queryKey: getUserMasqueradeQueryKey });
    },
    successToastMessage: 'Successfully unmasked',
    errorToastMessage: 'Failed to unmask',
    ...options,
  });
}
